/**
 * Document Status - mirrors CSC_CORE DocumentStatusEnum
 * Shared across features (material-requests, receiving, mro-dashboard, etc.)
 */
export enum DocumentStatus {
  Draft = 0,
  Open = 1,
  Closed = 2,
  Cancelled = 3,
}
